import { render } from "./ListInvoices.vue?vue&type=template&id=2c5f9d94"
import script from "./ListInvoices.vue?vue&type=script&lang=js"
export * from "./ListInvoices.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__